"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMessage = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Culligan.Protocol.V3.Message';
const createMessage = (channel, data) => {
    return effect_1.Schema.Struct({ channel: effect_1.Schema.tag(channel), data }).annotations({
        identifier: `${exports.NAMESPACE}.Message<"${channel}">`,
        description: `An object containing the channel name (\`"${channel}"\`) and the message data`,
    });
};
exports.createMessage = createMessage;
//# sourceMappingURL=message.js.map